<template>
  <div>
    <!-- 筛选 -->
    <el-form ref="Form" :inline="true" class="searchBoxLine my-search-line" :model="searchForm">
      <el-form-item label="申请单号：" prop="deliveryNum">
        <el-input v-model="searchForm.deliveryNum" placeholder="申请单号" maxlength="255" @input="e => searchForm.deliveryNum = handleInputRule (e)" />
      </el-form-item>
      <el-form-item label="合同编号：" prop="masterContractNum">
        <el-input v-model="searchForm.masterContractNum" placeholder="合同编号" maxlength="255" @input="e => searchForm.masterContractNum = handleInputRule (e)" @blur="searchForm.masterContractNum = (searchForm.masterContractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="项目名称：" prop="masterProjectName">
        <el-input v-model="searchForm.masterProjectName" placeholder="项目名称" maxlength="255" @input="e => searchForm.masterProjectName = handleInputRule (e)" />
      </el-form-item>
      <el-form-item label="唛头单号：" prop="markInfoNum">
        <el-input v-model="searchForm.markInfoNum" placeholder="唛头单号" maxlength="255" @input="e => searchForm.markInfoNum = handleInputRule (e)" />
      </el-form-item>
      <el-form-item label="申请日期:" prop="date">
        <el-date-picker
          v-model="date"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button ref="searchBtn" type="primary" :loading="isLoading" @click="initData('search')">
          查询
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="isLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="deliveryNum" label="申请单号" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleNum(row)">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterContractNum" label="合同编号" align="left" />
        <el-table-column prop="masterProjectName" label="项目名称" align="left" />
        <el-table-column prop="receiptAddress" label="收货地址" align="left" />
        <el-table-column prop="createTime" label="申请日期" align="left" />
        <el-table-column prop="invoiceNum" label="发货单号" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleGoods(row)">
              {{ row.invoiceNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="markInfoNum" label="唛头单号" align="left" />
        <el-table-column prop="printOrNot" label="是否已打印" align="left" width="100">
          <template v-slot="{row}">
            {{ row.printOrNot ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="transferFromCode" label="操作" align="left" fixed="right" width="50">
          <template v-slot="{row}">
            <el-button type="text" @click="handlePrint(row)">
              打印
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.pageIndex"
        :total="page.total"
        layout="total, prev, pager, next, jumper, sizes"
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>

    <!-- 申请单号 -->
    <requisitionedDetail
      ref="requisitionedDetailRef"
      type-id="partialId"
      title="查看发货单信息"
    />

    <!-- 发货产品清单  -->
    <goodsDetail ref="goodsDetail" />

    <!-- 打印窗口  -->
    <pringDialog ref="pringDialogRef" />
    <!-- 电信打印窗口  -->
    <dianxinPringDialog ref="dianxinPringDialogRef" />
  </div>
</template>

<script>
import { handleInputRule } from '@/libs/util.js';
// 申请单号
import requisitionedDetail from '@/views/assistantContractList/appliedInvoice/requisitionedDetail';
// 发货产品清单
import goodsDetail from '../components/goodsDetail.vue';
// 打印窗口
import pringDialog from '../components/pringDialog.vue';
// 电信打印窗口
import dianxinPringDialog from '../components/dianxinPringDialog.vue';

import { pageQueryMarkInfo } from '@/API';

export default {
  components: {
    requisitionedDetail,
    goodsDetail,
    pringDialog,
    dianxinPringDialog
  },

  data () {
    return {
      isLoading: false,
      date: [],
      searchForm: {},
      tableData: [],
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },

  created () {
    this.initData();
  },

  methods: {
    handleInputRule,
    initData (type) {
      this.isLoading = true;
      if (type === 'search') {
        this.page.pageIndex = 1;
      }
      const params = {
        printOrNot: true,
        ...this.searchForm,
        ...this.page,
        createBeginTime: (this.date && this.date.length > 0) ? this.date[0] : '',
        createEndTime: (this.date && this.date.length > 0) ? this.date[1] : ''
      };
      pageQueryMarkInfo(params).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.page.total = data.total;
          this.tableData = data.list;
          this.isLoading = false;
        }
      }).catch(e => {
        this.isLoading = false;
      });
    },

    // 申请单号
    handleNum (row, isNotOnlyHzdh = false) {
      this.$refs.requisitionedDetailRef.openDialog({ ...row, id: row.partialId }, isNotOnlyHzdh);
    },

    // 发货产品清单
    handleGoods (row) {
      this.$refs.goodsDetail.openDialog(row);
    },

    handerSizeChange () {
      this.page.pageIndex = 1;
      this.initData();
    },

    handerCurrentChange () {
      this.initData();
    },

    resetForm () {
      this.date = [];
      this.searchForm = {};
      this.page.pageIndex = 1;
      this.page.pageSize = 10;
      this.initData();
    },

    // 打印
    handlePrint (row) {
      if (row.receiptNum && !row.markInfoNum) {
        this.handleNum(row, false);
        return;
      }
      if (row.markId === 34) {
        this.$refs.dianxinPringDialogRef.openDialog(row);
        return;
      }
      this.$refs.pringDialogRef.openDialog(row);
    }
  }
};
</script>

<style>
  .el-input__inner {
    width: 100% !important;
  }
</style>

<style lang="scss" scoped>
.my-search-line {
  margin-bottom: 12px;
}
</style>
